import {
  css, keyframes,
} from '@emotion/react';

export const spinAnimation = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`;

export const spinAnimationStyle = css({
  animationName: spinAnimation,
  animationDuration: '2s',
  animationTimingFunction: 'linear',
  animationIterationCount: 'infinite',
});
